module.exports = __webpack_public_path__ + "static/media/anc6kz.11b0e738.pdf";